import { publicConfig } from '@public-config';

import { Pointer, Transaction } from 'sync-engine';
import { Diagram } from 'models';

import { PayloadSDK } from 'services/PayloadSDK';
import { state as currentProjectState } from 'state/current-project';

import { ApiService } from './ApiService';

const ProjectDiagramService = {
    list: async () => {
        return await ApiService.get(`${publicConfig.urls.api}/projectDesignDiagrams`);
    },

    create: async (payload: any) => {
        const response = await ApiService.post(`${publicConfig.urls.api}/projectDesignDiagrams`, payload);

        return response?.doc;
    },

    adminFetch: async (idOrSlug: string): Promise<{ success: boolean; diagram: Diagram }> => {
        return await ApiService.get(
            `${publicConfig.urls.api}/projectDesignDiagrams/admin-fetch/${encodeURIComponent(idOrSlug)}`,
            { throwError: true },
        );
    },

    getByProjectId: async (projectId: string): Promise<Diagram[]> => {
        const { docs: diagrams } = await ApiService.get(
            `${publicConfig.urls.api}/projectDesignDiagrams?where[project][equals]=${projectId}`,
        );

        return diagrams;
    },

    update: async (diagramId: string, payload: Diagram) => {
        return await ApiService.patch(`${publicConfig.urls.api}/projectDesignDiagrams/${diagramId}`, payload);
    },

    delete: async (diagramId: string) => {
        return await ApiService.delete(`${publicConfig.urls.api}/projectDesignDiagrams/${diagramId}`);
    },

    restore: async (diagramId: string) => {
        return await ApiService.post(`${publicConfig.urls.api}/projectDesignDiagrams/${diagramId}/restore`);
    },

    sync: async (diagramId: string, transactions: Transaction[], pointer: Pointer) => {
        const response = await ApiService.post(`${publicConfig.urls.api}/projectDesignDiagrams/${diagramId}/sync`, {
            transactions,
            pointer,
        });

        if (!response?.success) {
            throw new Error(`ProjectDiagramService.sync failed: ${response?.error}`);
        }

        const result: {
            transactions: Transaction[];
        } = {
            transactions: response.transactions,
        };

        return result;
    },

    rename: async (diagramId: string, name: string) => {
        await PayloadSDK.update({
            collection: 'projectDesignDiagrams',
            id: diagramId,
            data: {
                name,
            },
        });

        (currentProjectState.diagrams || []).forEach((diagram) => {
            if (diagram.id === diagramId) {
                diagram.name = name;
            }
        });
    },
};

export { ProjectDiagramService };
